class DiscountMessage extends HTMLElement {
  connectedCallback() {
    const defaultMessage = this.dataset.defaultMessage || '';
    const showDefaultMessage = this.dataset.showMessage;
    const timeMessage = this.dataset.timeMessage || '';
    const parseCustomDate = (dateStr) => {
      if (!dateStr) return null;
      const cleaned = dateStr
        .replace(/^[A-Za-z]+,\s*/, '')
        .replace(' at', '');
      return new Date(cleaned);
    };
    const startDate = parseCustomDate(this.dataset.startDate);
    const endDate = parseCustomDate(this.dataset.endDate);
    const now = new Date();
    if (startDate && now < startDate) {
      this.innerText = defaultMessage;
    } 
    else if ( startDate && now >= startDate && (!endDate || now <= endDate)) {
      this.innerText = timeMessage;
    } 
    else if (showDefaultMessage == 'true') {
      this.innerText = defaultMessage;
    }
  }
}

customElements.define('discount-message', DiscountMessage);
